export default {
  path: '/weform-submitsuccess',
  auth: false,
  preload: false,
  key: 'weForm',
  component: () => import('./index')
};
